import msLocale from 'element-ui/lib/locale/lang/ms'
import home from './ms/home'

const ms = {
    language: 'Melayu',
    message: {
        'home': home,
    },
    '手机号码最小长度为8位': "Panjang minimum nombor telefon bimbit ialah 8 digit.",
    '邮箱账号名称最小长度为6位': "Panjang minimum nama akaun e-mel ialah 6 aksara.",
    '邮箱只能包含英文，数字等字符': "Peti mel hanya boleh mengandungi aksara seperti bahasa Inggeris dan nombor",
    '请选择正确的收货地址': "Sila pilih alamat penghantaran yang betul.",
    ...msLocale
}
export default ms
